import { forwardRef } from 'react';

/**
 * Standard editorial container — caps width at content (1200px) and adds
 * responsive horizontal padding. Use `wide` for full-bleed sections.
 *
 * Forwards refs so callers can attach ResizeObserver / IntersectionObserver
 * via the rendered element.
 *
 * @param {object} props
 * @param {React.ElementType} [props.as='div']
 * @param {'article'|'content'|'wide'} [props.size='content']
 *
 * @example
 *   <Container size="wide" className="py-12">…</Container>
 */
const Container = forwardRef(function Container(
  { children, as: Tag = 'div', size = 'content', className = '', ...rest },
  ref,
) {
  const max =
    {
      article: 'max-w-article',
      content: 'max-w-content',
      wide: 'max-w-wide',
    }[size] ?? 'max-w-content';

  return (
    <Tag ref={ref} className={`mx-auto w-full ${max} px-4 sm:px-6 lg:px-8 ${className}`} {...rest}>
      {children}
    </Tag>
  );
});

export default Container;
